<template>
    <v-dialog v-model="show" scrollable max-width="700" persistent no-click-animation>
        <v-card>
            <v-card-title primary-title class="headline grey lighten-2 pa-0">
                <v-layout row justify-space-between align-center>
                    <div class="ml-3">{{ $t('massCalling') | capitalizeAll }}</div>
                    <v-btn flat icon @click="close">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-layout>
            </v-card-title>
            <v-card-text style="height: 500px">
                <v-form v-model="formValid" ref="form">
                    <v-select
                        v-model="selected.reason_code"
                        :items="reason_codes"
                        item-text="value"
                        item-value="code"
                        :label="$t('reason_code') | capitalize"
                        :rules="formRules.required"
                        return-object
                    ></v-select>
                    <div class="data-table">
                        <v-data-table
                            :headers="headers"
                            :items="customers"
                            :hide-actions="true"
                            :rows-per-page-items="[15, 30, 50, 100, 500]"
                        >
                            <template v-slot:items="props">
                                <td>{{ props.item.name }}</td>
                                <td>{{ getPrimaryPhoneNumber(props.item) }}</td>
                                <td>
                                <span class="row-actions">
                                    <v-icon @click="remove(props.item)" class="action-icon black--text">
                                        mdi-close
                                    </v-icon>
                                </span>
                                </td>
                            </template>
                        </v-data-table>
                    </div>
                </v-form>
            </v-card-text>
            <div>
                <v-divider></v-divider>
                <v-spacer></v-spacer>
                <v-card-actions class="flex-justify-content-end">
                    <v-btn color="primary" depressed
                           :disabled="!selected.reason_code || dataLoading"
                           @click="submit">
                        Request Now
                    </v-btn>
                </v-card-actions>
            </div>
        </v-card>
    </v-dialog>
</template>
<script>
import CampaignService from '@/services/campaign.service'
import FormMixin from '@/modules/fptai/mixins/FormMixin'
import {mapState} from 'vuex'

export default {
    name: 'CampaignMassRequestConsentZalo',
    mixins: [
        FormMixin
    ],
    data() {
        return {
            show: false,
            dataLoading: false,
            formValid: false,
            customers: [],
            selected: {},
            call_type: 'audio',
            reason_codes: [
                {
                    code: "101",
                    value: "Xác nhận thông tin khách hàng"
                },
                {
                    code: "102",
                    value: "Xử lý khiếu nại"
                },
                {
                    code: "103",
                    value: "Thẩm định hồ sơ"
                }
            ],
            headers: [
                {
                    text: 'Name',
                    align: 'left',
                    sortable: true,
                    value: 'name'
                },
                {
                    text: 'Telephone',
                    align: 'left',
                    sortable: true,
                    value: 'phone_number'
                },
                {
                    text: 'Action',
                    value: 'action',
                    sortable: false
                }
            ]
        }
    },
    computed: {
        ...mapState({
            campaign: state => state.campaign.campaign
        })
    },
    methods: {
        open(customers) {
            this.show = true
            this.resetModel()
            if (customers) {
                this.customers = [...customers]
            }
        },
        close() {
            this.$emit('on-close', this.customers)
            this.resetModel()
            this.show = false
        },
        submit(event) {
            if (event) {
                event.preventDefault()
            }
            if (this.formValid) {
                this.dataLoading = true
                let customer_ids = this.customers.reduce((ids, customer) => {
                    return ids = [...ids, customer.id]
                }, [])
                let phone_numbers = this.customers.reduce((ids, customer) => {
                    return ids = [...ids, customer.phone_numbers[0].phone_number]
                }, [])
                let customers = []
                for (let i = 0; i < customer_ids.length; i++) {
                    customers.push({'customer_id': customer_ids[i], 'phone_number': phone_numbers[i]})
                }
                let model = {
                    campaign_id: this.$route.params['campaignId'],
                    call_type: this.call_type,
                    reason_code: this.selected.reason_code,
                    customers: customers

                }
                CampaignService.requestConsentZalo(model).then(res => {
                    this.$appService.toastSuccess(this.$t('Data successfully saved!'))
                    this.dataLoading = false
                    this.$emit('success')
                    this.close()
                }, err => {
                    this.dataLoading = false
                    this.$appService.handleRequestError(this.$t('Something went wrong !'))
                })
            } else {
                this.$refs.form.validate()
            }
        },
        remove(customer) {
            this.customers = [...this.customers.filter(item => item.id !== customer.id)]
        },
        resetModel() {
            this.customers = []
            this.voices = []
            this.selected = {}
        },
        getPrimaryPhoneNumber(customer) {
            let min = 10000
            let primaryPhoneNumber = null
            for (let phoneNumber of customer.phone_numbers) {
                if (phoneNumber.priority < min) {
                    min = phoneNumber.priority
                    primaryPhoneNumber = phoneNumber.phone_number
                }
            }
            return primaryPhoneNumber
        }
    },
    beforeDestroy() {
        this.resetModel()
    }
}
</script>
<style scoped>
::v-deep .v-slider__thumb-label {
    border-radius: 50% 50% 0;
    transform: translateY(-20%) translateY(-12px) translateX(-50%) rotate(45deg);

}
</style>
